import * as lpActions from '@features/loyalty-program/store/actions/loyalty-program.actions';
import * as tenantActions from '@rd/core/tenant/store/actions/tenant.actions';
import { HttpError, TransactionStatus } from '@rd/types';
import { RewardsProgram } from '@rd/types/rewards_program.type';
import { toObject } from '@rd/utils/array.utils';
import { isNotNull } from '@rd/utils/isNotNull';

export interface RewardsProgramState {
  rewardsPrograms: Record<string, RewardsProgram>;
  rewardsProgramIndex: {
    bootstrapLoading: TransactionStatus;
    bootstrapError: HttpError | null;

    loyaltyProgramLoading: TransactionStatus;
    loyaltyProgramError: HttpError | null;
  };
}

const initialRewardsProgramState: RewardsProgramState = {
  rewardsPrograms: {},

  rewardsProgramIndex: {
    bootstrapLoading: TransactionStatus.INITIAL,
    bootstrapError: null,
    loyaltyProgramLoading: TransactionStatus.INITIAL,
    loyaltyProgramError: null,
  },
};

export function rewardsProgramReducer(
  state: RewardsProgramState = initialRewardsProgramState,
  action: tenantActions.TenantActions | lpActions.LoyaltyProgramActions,
): RewardsProgramState {
  switch (action.type) {
    case tenantActions.TenantActionTypes.LOAD_BOOTSTRAP: {
      return {
        ...state,
        rewardsProgramIndex: {
          ...state.rewardsProgramIndex,
          bootstrapError: null,
          bootstrapLoading: TransactionStatus.LOADING,
        },
      };
    }
    case tenantActions.TenantActionTypes.LOAD_BOOTSTRAP_FAIL: {
      return {
        ...state,
        rewardsProgramIndex: {
          ...state.rewardsProgramIndex,
          bootstrapLoading: TransactionStatus.FAIL,
          bootstrapError: action.payload,
        },
      };
    }
    case tenantActions.TenantActionTypes.LOAD_BOOTSTRAP_SUCCESS: {
      return {
        ...state,
        rewardsPrograms: {
          ...state.rewardsPrograms,
          ...toObject([action.payload.rewardsProgram], 'id'),
        },
        rewardsProgramIndex: {
          ...state.rewardsProgramIndex,
          bootstrapError: null,
          bootstrapLoading: TransactionStatus.SUCCESS,
        },
      };
    }
    case lpActions.LoyaltyProgramActionTypes.LOAD_LOYALTY_PROGRAMS: {
      return {
        ...state,
        rewardsProgramIndex: {
          ...state.rewardsProgramIndex,
          loyaltyProgramLoading: TransactionStatus.LOADING,
          loyaltyProgramError: null,
        },
      };
    }

    case lpActions.LoyaltyProgramActionTypes.LOAD_LOYALTY_PROGRAMS_FAIL: {
      return {
        ...state,
        rewardsProgramIndex: {
          ...state.rewardsProgramIndex,
          loyaltyProgramError: action.payload,
          loyaltyProgramLoading: TransactionStatus.FAIL,
        },
      };
    }
    case lpActions.LoyaltyProgramActionTypes.LOAD_LOYALTY_PROGRAMS_SUCCESS: {
      const lpRewardsPrograms: RewardsProgram[] = action.payload
        .map((lp) => {
          if (lp.rewardsProgram) {
            const { rewardsProgram, ...rest } = lp;
            if (rewardsProgram) {
              const rp: RewardsProgram = {
                ...rewardsProgram,
                loyaltyProgram: rest,
                loyaltyProgramId: rest.id,
              };
              return rp;
            }
          }
          return null;
        })
        .filter(isNotNull);

      const rpMap = {
        ...state.rewardsPrograms,
        ...toObject(lpRewardsPrograms, 'id'),
      };

      return {
        ...state,
        rewardsPrograms: rpMap,
        rewardsProgramIndex: {
          ...state.rewardsProgramIndex,
          loyaltyProgramLoading: TransactionStatus.SUCCESS,
          loyaltyProgramError: null,
        },
      };
    }
    default:
      return state;
  }
}
